import dayjs from 'dayjs';

function getDeliveryDates(minDeliveryTime: number | null = 0, maxDeliveryTime?: number | null) {
  const today = dayjs();
  const dateFrom = minDeliveryTime !== null ? today.add(minDeliveryTime + 1, 'days') : today;

  if (!maxDeliveryTime) {
    if (today.date() === dateFrom.date()) {
      return dayjs(dateFrom).format('сегодня');
    } else if (today.add(1, 'day').date() === dateFrom.date()) {
      return dayjs(dateFrom).format('завтра');
    } else {
      return dayjs(dateFrom).format('dddd, D MMMM');
    }
  }

  let dateTo = today.add(maxDeliveryTime + 1, 'days');
  if (!dateTo.isAfter(dateFrom, 'day')) {
    dateTo = dateFrom.add(1, 'day');
  }

  const isSameMonth = dayjs(dateFrom).month() === dayjs(dateTo).month();
  const formattedDateFrom = dayjs(dateFrom).format(isSameMonth ? 'D' : 'D MMMM ');
  const formattedDateTo = dayjs(dateTo).format(isSameMonth ? 'D MMMM' : ' D MMMM');

  return `${formattedDateFrom}-${formattedDateTo}`;
}

export default getDeliveryDates;
